module.exports = __webpack_public_path__ + "img/banner-03.6a38e623.jpg";